import { AfterViewInit, Component, ElementRef, Input, OnInit, OnChanges, Optional, Self, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'carbon-select-option',
  templateUrl: './carbon-select-option.component.html',
  styleUrls: ['./carbon-select-option.component.css']
})
export class CarbonSelectOptionComponent implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor {

  @ViewChild('selectElement', { static: false }) selectElementRef!: ElementRef<HTMLSelectElement>;

  @Input() id!: string;
  @Input() label!: string;
  @Input() require!: boolean;
  @Input() readonly!: boolean;
  @Input() dataOption: { value: string; nome: string }[] = [];
  @Input() showValueBeforeNameAtList: boolean = false;

  value = '';
  disabled = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get control() {
    return this.ngControl ? this.ngControl.control : null;
  }

  get isInvalid(): boolean {
    return !!this.control && this.control.invalid && (this.control.dirty || this.control.touched);
  }

  get isValid(): boolean {
    return !!this.control && this.control.valid && this.value !== '' && (this.control.dirty || this.control.touched);
  }

  get optionsToRender(): { value: string; nome: string }[] {
    const options = this.dataOption || [];
    if (this.value === null || this.value === undefined || this.value === '') return options;

    const selectedValue = String(this.value);
    const hasValue = options.some(option => option && option.value !== null && option.value !== undefined && String(option.value) === selectedValue);
    if (hasValue) return options;

    const matchingLabel = options.find(option => option && option.nome !== null && option.nome !== undefined && String(option.nome) === selectedValue);
    if (matchingLabel) {
      return [{ value: selectedValue, nome: matchingLabel.nome }].concat(options);
    }

    return [{ value: selectedValue, nome: selectedValue }].concat(options);
  }

  get errorMessage(): string {
    if (!this.control || !this.control.errors) return '';

    if (this.control.errors['required']) return 'Campo obrigatório';

    return 'Valor inválido';
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.reaplicarValorNoSelectNativo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataOption']) {
      // Quando as opções chegam depois do valor, forçamos o select nativo a reaplicar
      // o valor para evitar ficar visualmente em branco.
      setTimeout(() => this.reaplicarValorNoSelectNativo(), 0);
    }
  }

  writeValue(value: any): void {
    this.value = value !== null && value !== undefined ? String(value) : '';
    this.reaplicarValorNoSelectNativo();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelect(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.value = value;
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
  }

  private reaplicarValorNoSelectNativo(): void {
    if (!this.selectElementRef || !this.selectElementRef.nativeElement) return;
    const select = this.selectElementRef.nativeElement;
    const valorAtual = this.value !== null && this.value !== undefined ? String(this.value) : '';
    try { select.value = valorAtual; } catch (e) { /* noop */ }
  }
}
